import React, { useEffect, useState } from 'react'
import { ColumnNormal } from '../../ReportComponent/components/Model'
import PageIncidentService from './PageIncidentService'
import { Table, Tooltip } from 'antd'

interface Param {
    dataTransfer: any[]
    columnsAllTicketList: string[]
    columnsAllTicketObjList: ColumnNormal[]
    total: number
    range: any
    handleAllTicketChange: Function
}

type Props = Param
const ColumnAllTicket: React.FC<Props> = (props: Props) => {
    const [tempColumns, setTempColumns] = useState<ColumnNormal[]>([])
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    useEffect(() => {
        if (props.columnsAllTicketList && props.columnsAllTicketObjList) {
            const temp: ColumnNormal[] = []
            props.columnsAllTicketList.forEach((it) => {
                const findDataIndex = props.columnsAllTicketObjList.find((data) => data.dataIndex === it)
                if (findDataIndex) {
                    findDataIndex.render = (text, record) => {
                        return (<>
                            <Tooltip placement="bottom" title={text?.length > 50 ? text : null}>
                                {text !== null && text?.toString()?.length > 50 ? text?.toString().substring(0, 50) + '...' : text?.toString()}
                            </Tooltip>
                        </>)
                    }
                    temp.push(findDataIndex)
                }
            })
            console.log('tempColumns', temp)
            setTempColumns(temp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.columnsAllTicketList, props.columnsAllTicketObjList])

    useEffect(() => {
        if (pageSize) {
            PageIncidentService.getInstance().data.pageAllTicket = 1
            setPage(1)
            props.handleAllTicketChange()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize])

    useEffect(() => {
        if (!props.range) {
            setPage(1)
            PageIncidentService.getInstance().data.pageAllTicket = 1
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.range])

    const handleOnClickPageNumber = (page: number) => {
        setPage(page)
        PageIncidentService.getInstance().data.pageAllTicket = page
        props.handleAllTicketChange()
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPageSize(pagination.pageSize)
        PageIncidentService.getInstance().data.pageSizeAllTicket = pagination.pageSize
    }

    return (
        <div>
            <Table scroll={{x: true}} dataSource={tempColumns.length === 0 ? [] : props.dataTransfer} columns={tempColumns}
                pagination={ props.range && props.columnsAllTicketList.length !== 0 ? {
                    current: page,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    total: props.dataTransfer.length !== 0 ? props.total : 0,
                    onChange: (event) => {
                        handleOnClickPageNumber(event)
                    }
                } : false}
                onChange={handleTableChange}
                className="ReportTable" rowKey={'serialNumber'}/>
        </div>
    )
}

export default ColumnAllTicket
